import { axios } from '@/plugins/axios';
import { PaymentTermItem } from '@/models/quote-template';

export class QuotePaymentTermItemService {
  private endpoint: string;

  constructor() {
    this.endpoint = 'v1/quotes/templates/payment-terms/';
  }

  async createQuotePaymentTerm(paymentTerm: PaymentTermItem) {
    return axios
      .post<PaymentTermItem>(`${this.endpoint}`, paymentTerm)
      .then(({ data }) => data);
  }

  async fetchQuotePaymentTerms(language = 'en') {
    return axios
      .get<PaymentTermItem[]>(`${this.endpoint}`, {
        headers: {
          'Accept-Language': language
        }
      })
      .then(({ data }) => data);
  }

  async fetchQuotePaymentTerm(id: number) {
    return axios
      .get<PaymentTermItem>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  async updateQuotePaymentTerm(paymentTerm: PaymentTermItem) {
    return axios
      .patch<PaymentTermItem>(`${this.endpoint}${paymentTerm.id}/`, paymentTerm)
      .then(({ data }) => data);
  }

  async deleteQuotePaymentTerm(id: number) {
    return axios.delete(`${this.endpoint}${id}/`);
  }
}
